import './_vportal.js';

window.addEventListener("load", function () {
  var bannerEl = document.querySelector('.swiper-news-banner');
  if (bannerEl) {
    new Swiper(bannerEl, {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-news-banner-pagination",
        clickable: true,
        enabled: true,
      },
      // Switch to arrows on larger screens
      breakpoints: {
        769: {
          
          
        },
      },
    });
  }

  $(".news").each(function () {
    var postsTag = "#" + $(this).attr("id");
    $().vPortal({
      container: postsTag,
      el: {
        tabContainer: '.news-tabs > a',
        resultContainer: '.news-list',
        viewAll: '.viewAll',
      },
      paginationOptions: {
      }
    });

  });
});